


import { GET_MODALIDAD, HEADERS } from 'constants/endpoints';
import axios from 'axios';

export const getModalidad = () => {
	return new Promise((resolve, reject) => {
		return axios({
			url: GET_MODALIDAD,
			method: 'GET',
			headers: HEADERS,
			// params: {
			// 	anio,
			// 	mes,
			// },
		})
			.then(response => response)
			.then(json => {
				return resolve({ data: json.data });
			})
			.catch(err => {
				console.log(err);
				return reject(err);
			});
	});
};